import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type UserRole = 'user' | 'creator' | 'admin';

interface DevModeState {
    isDevMode: boolean;
    selectedRole: UserRole | null;
    actualRole: UserRole | null;
}

const initialState: DevModeState = {
    isDevMode: process.env.NODE_ENV === 'development',
    selectedRole: null,
    actualRole: null,
};

const devRoleSlice = createSlice({
    name: 'devRole',
    initialState,
    reducers: {
        setDevMode: (state, action: PayloadAction<boolean>) => {
            state.isDevMode = action.payload;
        },
        setSelectedRole: (state, action: PayloadAction<UserRole>) => {
            state.selectedRole = action.payload;
            if (typeof window !== 'undefined') {
                localStorage.setItem('devSelectedRole', action.payload);
            }
        },
        setActualRole: (state, action: PayloadAction<UserRole>) => {
            state.actualRole = action.payload;
        },
        clearSelectedRole: (state) => {
            state.selectedRole = null;
            if (typeof window !== 'undefined') {
                localStorage.removeItem('devSelectedRole');
            }
        },
        initializeFromStorage: (state) => {
            if (typeof window !== 'undefined') {
                const stored = localStorage.getItem('devSelectedRole') as UserRole | null;
                if (stored) {
                    state.selectedRole = stored;
                }
            }
        },
    },
});

const {
    setDevMode,
    setSelectedRole,
    setActualRole,
    clearSelectedRole,
    initializeFromStorage,
} = devRoleSlice.actions;

export const devRoleActions = {
    setDevMode,
    setSelectedRole,
    setActualRole,
    clearSelectedRole,
    initializeFromStorage,
};

export default devRoleSlice;